import { Contract } from "@ethersproject/contracts";
import { abis, addresses } from "@my-app/contracts";
import { useCall, useCalls } from "@usedapp/core";
import { CHAINS } from "../constants";

export function useJobsInfo(jobsLength, chainId) {
  console.log("jobsLengthhhh: ", jobsLength);
  let calls = [];

  for (var i = 1; i <= jobsLength; i++) {
    calls.push({
      contract: new Contract(addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase, abis.epochBase),
      method: "jobInfo",
      args: [i],
    });
  }

  const results = useCalls(calls) ?? [];
  results.forEach((result, idx) => {
    console.log("result: ", result);
    if (result && result.error) {
      console.error(
        `Error encountered calling 'totalSupply' on ${calls[idx]?.contract.address}: ${result.error.message}`
      );
    }
  });

  return results.map((result) => result?.value).filter((result) => Boolean(result));
}

export function useJobsParams(jobsLength, chainId) {
  console.log("jobsLengthhhh: ", jobsLength);
  let calls = [];

  for (var i = 1; i <= jobsLength; i++) {
    calls.push({
      contract: new Contract(addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase, abis.epochBase),
      method: "jobParams",
      args: [i],
    });
  }

  const results = useCalls(calls) ?? [];
  results.forEach((result, idx) => {
    console.log("result: ", result);
    if (result && result.error) {
      console.error(
        `Error encountered calling 'totalSupply' on ${calls[idx]?.contract.address}: ${result.error.message}`
      );
    }
  });

  return results.map((result) => result?.value).filter((result) => Boolean(result));
}

export function useActiveEpochWallet(address, chainId) {
  const { value, error } =
      useCall(
          address && {
            contract: new Contract(addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochWalletRegistry, abis.epochWalletRegistry), // instance of called contract
            method: "activeWallet", // Method to be called
            args: [address], // Method arguments - address to be checked for balance
          }
      ) ?? {};
    if(error) {
      console.error(error.message)
      return undefined
    }
    return value?.[0]
}